import * as DatasetHelper from '../dataset-helper';

/**
 * Calculate the {@code Variance} based on the number of categories.
 */
export default function calculate(statistics, dataset, categoryFieldId, calculationStepDefn) {

  const categoryField = DatasetHelper.findField(dataset, categoryFieldId);
  const { categories } = categoryField;
  const numOfCategories = categories.length;
  const { propertyName } = calculationStepDefn;
  const resultPropertyName = calculationStepDefn.result;

  // Calculate mean.
  let accumulator = 0.0;
  categories.forEach((category) => {
    const categoryResult = statistics[category.value];
    const value = categoryResult[propertyName] || 0.0;
    accumulator += value;
  });
  const mean = accumulator / numOfCategories;

  // Calculate variance.
  let varianceAccumulator = 0.0;
  categories.forEach(category => {
    const categoryResult = statistics[category.value];
    const value = categoryResult[propertyName] || 0.0;
    varianceAccumulator += (value - mean) ** 2;
  });
  const variance = (numOfCategories > 1 ? varianceAccumulator / (numOfCategories - 1) : 0.0);
  statistics[resultPropertyName] = variance;
}



// WEBPACK FOOTER //
// ./src/app/utils/calculators/variance-calculator.js